// vendor
import React from "react";

import { FreeAssessmentHeaderContainer } from "./styled";

function FreeAssessmentHeader({ minHeight }) {
  return (
    <FreeAssessmentHeaderContainer
      className="page-header"
      image={require("../../assets/img/landing-page-image-2.jpg")}
      minHeight={minHeight}
    >
      <div className="filter" />
    </FreeAssessmentHeaderContainer>
  );
}

export default FreeAssessmentHeader;
